var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin"},[_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('div',{staticClass:"logo"}),_c('Menu')],1),_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('Main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }